app.controller("patientTransferController", [
	"$scope",
	"PatientAPI",
	"Session",
	"patientId",
	"onSuccess",
	"onCancel",
	function ($scope, PatientAPI, Session, patientId, onSuccess, onCancel) {

		$scope.isLoading = true;
		$scope.isProcessing = false;
		$scope.patient = null;
		$scope.Session = Session;
		$scope.viewState = 'details';

		PatientAPI.getPatient(patientId).then(
			function (resp) {
				$scope.patient = resp.data;
				$scope.isLoading = false;
			},
			function (err) {
				console.error("Failed to fetch patient", err && err.status);
				$scope.isLoading = false;
				$scope.error = "Could not load patient details.";
			}
		);

		$scope.promptTransfer = function () {
			$scope.viewState = 'confirm';
		};

		$scope.executeTransfer = function () {
			if ($scope.isProcessing) return;
			$scope.isProcessing = true;

			PatientAPI.transfer($scope.patient.id, Session.userId, Session.practice.id)
				.then(function (resp) {
					$scope.isProcessing = false;
					$scope.viewState = 'success';
					$scope.patient = resp.data;
				})
				.catch(function (err) {
					console.error("Patient transfer failed", err && err.status);
					$scope.isProcessing = false;
					$scope.error = "An error occurred during transfer.";
				});
		};

		$scope.closeModal = function () {
			if ($scope.viewState === 'success') {
				if (onSuccess) onSuccess($scope.patient);
			} else {
				if (onCancel) onCancel();
			}
			$scope.$hide();
		};
	}
]);